import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import WishCard from "../Components/Cards/CardWish";
import Headline from "../Components/Elements/Headline";
import Toast from "../Components/Elements/Toast";
import { fetchPublicWishlist } from "../api";
import PublicNav from "../Components/Navigation/PublicNav";
import { AuthContext } from "../context/context";
import { useLanguage } from "../context/LanguageContext";

export default function PublicWishlist() {
  const { year, token } = useParams();
  const [wishes, setWishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { userData } = useContext(AuthContext);
  const { copy } = useLanguage();

  useEffect(() => {
    const fetchWishlist = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchPublicWishlist(token, year);
        setWishes(data.wishes);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchWishlist();
  }, [token, year]);

  return (
    <div className="flex flex-col w-full">
      <PublicNav />
      <div className="w-full min-h-screen flex flex-col background-page-color flex-1 pb-25 pt-4 sm:pb-6 md:pb-8 px-2 sm:px-4 md:px-6 gap-5">
        <Headline
          headline={
            userData?.first_name
              ? copy.public_wishlist.headline.replace(
                  "{name}",
                  userData.first_name
                )
              : copy.public_wishlist.headline_fallback
          }
        />
        {loading && <div>{copy.public_wishlist.loading}</div>}
        {error && (
          <Toast message={error} type="error" onClose={() => setError("")} />
        )}
        {!loading && !error && wishes.length === 0 && (
          <div className="text-center text-lg">
            <p className="font-semibold">{copy.public_wishlist.empty.title}</p>
            <p>{copy.public_wishlist.empty.description}</p>
          </div>
        )}
        {!loading && !error && wishes.length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 mt-4">
            {wishes.map((wishlistItem, idx) => (
              <WishCard
                key={idx}
                wishlistItem={wishlistItem}
                showTitle={true}
                showPrice={true}
                publicView={true}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
